import { useContext } from "react";
import HeaderLogin from "../../Components/Common/HeaderLogin";
import { Context } from "../../Context/Context";

// style
import styles from "../../Styles/Authentication/LayoutLogin.module.css"
import Footer from "../../Components/Common/Footer";


const LayoutLogin = ({ children }) => {
    
    const { json } = useContext(Context);

    const content = json?.headerLogin;

    return (
        <>
            <HeaderLogin />
            <div className="container d-flex justify-content-center">
                <section className={styles.sectionLogin}>
                    <div className={styles.layoutLogo} onClick={() => window.open("https://wisercam.com/archives/624")}>
                        <img src="/imgs/wisercam login logo.png" alt="Wisercam" />
                        <a href="https://wisercam.com/terms-and-conditions/">
                            <button className="main-btn main-btn-fill">
                                {content.textRuls}
                            </button>
                        </a>
                    </div>
                    <div className={styles.layoutForm}>
                        {children}
                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
}

export default LayoutLogin;